module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"voiceMail":"Voice Message","audioTranscription":"Auto-generated audio transcription"},"es":{"voiceMail":"Mensaje de voz","audioTranscription":"Transcripción de audio auto-generada"}}')
  delete Component.options._Ctor
}
